const validateForm = (activeStep, formData, propertyType, serviceType,selfType) => {
  const newErrors = {};



  if (!formData.basicDetails.property_category) newErrors.property_category = "Select Property Category is required.";
  if (!formData.basicDetails.property_service) newErrors.property_service = "Select Looking To is required.";
  if (!formData.basicDetails.self) newErrors.self = "Describe yourself is required.";
  if (!formData.basicDetails.name) newErrors.name = "Name is required.";
  if (!formData.basicDetails.city_id) newErrors.city_id = "Select City is required.";
  if (!formData.basicDetails.email) newErrors.email = "Email is required.";
  if (formData.basicDetails.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.basicDetails.email)) {
    newErrors.email = "Please enter a valid email address.";
  }

  if (!formData.basicDetails.phone) newErrors.phone = "Phone is required.";
  if (formData.basicDetails.phone && !/^\d{10}$/.test(formData.basicDetails.phone)) {
    newErrors.phone = "Phone number must be exactly 10 digits.";
  }

  // Residential - sell
  if (selfType === 6 && propertyType === "residential" && serviceType === "sell") {


    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

     
      // if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['apartment','independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.buildup_area.trim()) {
          newErrors.buildup_area = "Build Up is required.";
        }
       if (parseFloat(formData.propertyDetails.carpet_area) > parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
        if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
        // if (!formData.propertyDetails.transaction_type) {
        //   newErrors.transaction_type = "Transaction Type is required.";
        // }
        // if (!formData.propertyDetails.brokerage_charge) {
        //   newErrors.brokerage_charge = "Select charge brokerage is required.";
        // }
        // if (!formData.propertyDetails.maintenance_charge) {
        //   newErrors.maintenance_charge = "Maintenance Charge is required.";
        // }
        if (['1'].includes(formData.propertyDetails.brokerage_charge)) {
          if (!formData.propertyDetails.brokerage_amount.trim()) {
            newErrors.brokerage_amount = " Brokerage Amount is required.";
          }
        }

      }
      if (['plot', 'agricultural_land'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.length.trim()) {
          newErrors.length = "Lenght is required.";
        }
        if (!formData.propertyDetails.width.trim()) {
          newErrors.width = "Width is required.";
        }
        if (!formData.propertyDetails.plot_area.trim()) {
          newErrors.plot_area = "Plot Area is required.";
        }
        if (!formData.propertyDetails.area_unit) {
          newErrors.area_unit = "Area Unit is required.";
        }
        // if (!formData.propertyDetails.transaction_type) {
        //   newErrors.transaction_type = "Transaction Type is required.";
        // }
        // if (!formData.propertyDetails.brokerage_charge) {
        //   newErrors.brokerage_charge = "Select charge brokerage is required.";
        // }
        if (['1'].includes(formData.propertyDetails.brokerage_charge)) {
          if (!formData.propertyDetails.brokerage_amount.trim()) {
            newErrors.brokerage_amount = " Brokerage Amount is required.";
          }
        }
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Cost is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyDetails.construction_status.trim()) newErrors.construction_status = "Choose Construction Status.";


      if (['under_construction'].includes(formData.propertyDetails.construction_status)) {
        if (!formData.propertyDetails.possession_date.trim()) {
          newErrors.possession_date = "Possession date is required";
        }
      }
      // if (!formData.propertyPrice.availableForm) newErrors.availableForm = "Available Form Date  is required.";
      // if (!formData.propertyPrice.securityDeposit) newErrors.securityDeposit = "Security Deposit Type is required.";
      // if (['custom'].includes(formData.propertyPrice.securityDeposit)) {
      //   if (!formData.propertyPrice.security_amount.trim()) {
      //     newErrors.builtup = "Build Up is required.";
      //   }
      // }
    }

  }
  if (selfType === 5 && propertyType === "residential" && serviceType === "sell") {


    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      
      // if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['apartment','independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.buildup_area.trim()) {
          newErrors.buildup_area = "Build Up is required.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
        if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
      }
      if (['plot', 'agricultural_land'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.length.trim()) {
          newErrors.length = "Lenght is required.";
        }
        if (!formData.propertyDetails.width.trim()) {
          newErrors.width = "Width is required.";
        }
        if (!formData.propertyDetails.plot_area.trim()) {
          newErrors.plot_area = "Plot Area is required.";
        }
        if (!formData.propertyDetails.area_unit) {
          newErrors.area_unit = "Area Unit is required.";
        }
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Cost is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyDetails.construction_status.trim()) newErrors.construction_status = "Choose Construction Status.";


      if (['under_construction'].includes(formData.propertyDetails.construction_status)) {
        if (!formData.propertyDetails.possession_date.trim()) {
          newErrors.possession_date = "Possession date is required";
        }
      }
      // if (!formData.propertyPrice.availableForm) newErrors.availableForm = "Available Form Date  is required.";
      // if (!formData.propertyPrice.securityDeposit) newErrors.securityDeposit = "Security Deposit Type is required.";
      // if (['custom'].includes(formData.propertyPrice.securityDeposit)) {
      //   if (!formData.propertyPrice.security_amount.trim()) {
      //     newErrors.builtup = "Build Up is required.";
      //   }
      // }
    }

  }

  if (selfType === 6 && propertyType === "residential" && serviceType === "rent") {


    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
      // if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['apartment','independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.buildup_area.trim()) {
          newErrors.buildup_area = "Build Up is required.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
        // if (!formData.propertyDetails.lock_period) {
        //   newErrors.lock_period = "Select lock in period is required.";
        // }
        if (['custom'].includes(formData.propertyDetails.lock_period)) {
          if (!formData.propertyDetails.lock_period_amount.trim()) {
            newErrors.lock_period_amount = "Lock in period Amount is required.";
          }
        }
        // if (!formData.propertyDetails.brokerage_charge) {
        //   newErrors.brokerage_charge = "Select charge brokerage is required.";
        // }
        if (['custom'].includes(formData.propertyDetails.brokerage_charge)) {
          if (!formData.propertyDetails.brokerage_amount.trim()) {
            newErrors.brokerage_amount = " Brokerage Amount is required.";
          }
        }
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Cost is required.";
      if (!formData.propertyDetails.available_from.trim()) newErrors.available_from = "Available From is required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";
      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }

  }

  if (selfType === 5 && propertyType === "residential" && serviceType === "rent") {


    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
      // if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['apartment','independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.buildup_area.trim()) {
          newErrors.buildup_area = "Build Up is required.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
      }
      if (['plot', 'agricultural_land'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.length.trim()) {
          newErrors.length = "Lenght is required.";
        }
        if (!formData.propertyDetails.width.trim()) {
          newErrors.width = "Width is required.";
        }
        if (!formData.propertyDetails.plot_area.trim()) {
          newErrors.plot_area = "Plot Area is required.";
        }
        if (!formData.propertyDetails.area_unit) {
          newErrors.area_unit = "Area Unit is required.";
        }
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Cost is required.";
      if (!formData.propertyDetails.available_from.trim()) newErrors.available_from = "Available From is required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";
      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }

  }

  // Residential - living
  if (propertyType === "residential" && serviceType === "living") {


    if (activeStep === 1) {
      if (!formData.propertyDetails.pg_name) newErrors.pg_name = "PG Name is required.";
      if (!formData.propertyDetails.pg_total_beds) newErrors.pg_total_beds = "Total Bed is required.";
      if (!formData.propertyDetails.pg_for) newErrors.pg_for = "Select pg is for required.";
      if (!formData.propertyDetails.pg_suitable_for) newErrors.pg_suitable_for = "Select Suitale is required.";
      if (!formData.propertyDetails.pg_meals_available) newErrors.pg_meals_available = "Select Meal Available is required.";
      if (['yes'].includes(formData.propertyDetails.pg_meals_available)) {
        if (!formData.propertyDetails.pg_meals_offering) newErrors.pg_meals_offering = "Select Meal Offering is required.";
      }
      if (!formData.propertyDetails.pg_notice_period) newErrors.pg_notice_period = "Notice Period is required.";
      if (!formData.propertyDetails.pg_lock_in) newErrors.pg_lock_in = "Lock Period is required.";
      if (!formData.propertyDetails.pg_common_area) newErrors.pg_common_area = "Select Common Area is required.";
    }
    if (activeStep === 2) {
      const roomDetailLength = Object.keys(formData.roomDetail || {}).length;
    
      if (roomDetailLength === 0) {
        newErrors.roomDetail1 = "At least one room detail is required.";
      } else {
        Object.keys(formData.roomDetail).forEach((priceIndex) => {
          const room = formData.roomDetail[priceIndex];
    
          if (!room.pricing?.trim()) newErrors[`roomDetail.${priceIndex}.pricing`] = "Rent is required.";
          if (!room.security_deposit_amount?.trim()) newErrors[`roomDetail.${priceIndex}.security_deposit_amount`] = "Security Deposit is required.";
          if (!room.pg_room_type) newErrors[`roomDetail.${priceIndex}.pg_room_type`] = "Select Room Type is required.";
        });
      }
    }
  
  }


  

  // commercial - Rent
  if (selfType === 6 && propertyType === "commercial" && serviceType === "rent") {

    if (activeStep === 1) {

      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (['office'].includes(formData.propertyDetails.property_type)) {

        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.property_condition) newErrors.property_condition = "Property Condition is required.";
        if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.carpet_area.trim()) {
            newErrors.carpet_area = "Carpet Area is required.";
          } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
            newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
          }

        }
        if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.construction_status) newErrors.construction_status = "Construction Status is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['retailshop', 'showroom'].includes(formData.propertyDetails.property_type)) {
  
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.suitable_for) newErrors.suitable_for = "Suitable for is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['warehouse'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['plot'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.plot_area.trim()) newErrors.plot_area = "Plot Area is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
      }

      if (['other'].includes(formData.propertyDetails.property_type)) {

        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }

        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.property_name.trim()) newErrors.property_name = "Property Name is required.";
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Price is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";


      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }
  }

  if (selfType === 5 && propertyType === "commercial" && serviceType === "rent") {

    if (activeStep === 1) {

      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (['office'].includes(formData.propertyDetails.property_type)) {

        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.property_condition) newErrors.property_condition = "Property Condition is required.";
        if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.carpet_area.trim()) {
            newErrors.carpet_area = "Carpet Area is required.";
          } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
            newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
          }

        }
        if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.construction_status) newErrors.construction_status = "Construction Status is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['retailshop', 'showroom'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['warehouse'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['plot'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.plot_area.trim()) newErrors.plot_area = "Plot Area is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
      }

      if (['other'].includes(formData.propertyDetails.property_type)) {

        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (!formData.propertyDetails.available_from) newErrors.available_from = "Available From is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }

        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.property_name.trim()) newErrors.property_name = "Property Name is required.";
      }
    }
    if (activeStep === 2) { 
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Price is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";


      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }
  }

  // commercial - sell
  if (selfType === 5 && propertyType === "commercial" && serviceType === "sell") {
    if (activeStep === 1) {

      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (['office'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";

        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.property_condition) newErrors.property_condition = "Property Condition is required.";
        if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.carpet_area.trim()) {
            newErrors.carpet_area = "Carpet Area is required.";
          } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
            newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
          }
        }
        if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.construction_status) newErrors.construction_status = "Construction Status is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['retailshop', 'showroom'].includes(formData.propertyDetails.property_type)) {

        //if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }

        //if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['warehouse'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['plot'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.plot_area.trim()) newErrors.plot_area = "Plot Area is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
      }

      if (['other'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }

        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.property_name.trim()) newErrors.property_name = "Property Name is required.";
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Price is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";


      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }
  }

  if (selfType === 6 && propertyType === "commercial" && serviceType === "sell") {
    if (activeStep === 1) {

      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";

      if (['office'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";

        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.property_condition) newErrors.property_condition = "Property Condition is required.";
        if (['ready_use'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.carpet_area.trim()) {
            newErrors.carpet_area = "Carpet Area is required.";
          } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
            newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
          }
        }
        if (['bare_shell'].includes(formData.propertyDetails.property_condition)) {
          if (!formData.propertyDetails.construction_status) newErrors.construction_status = "Construction Status is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['retailshop', 'showroom'].includes(formData.propertyDetails.property_type)) {

        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }

        //if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['warehouse'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
      }

      if (['plot'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.plot_area.trim()) newErrors.plot_area = "Plot Area is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
      }

      if (['other'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.possession_status) newErrors.possession_status = "Possession Status is required.";
        if (['ready_to_use'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.property_age.trim()) newErrors.property_age = "Property Age is required.";
        }
        if (['under_construction'].includes(formData.propertyDetails.possession_status)) {
          if (!formData.propertyDetails.possession_date) newErrors.possession_date = "Possession Date is required.";
        }

        if (!formData.propertyDetails.zone_type) newErrors.zone_type = "Zone Type is required.";
        if (!formData.propertyDetails.ownership) newErrors.ownership = "Ownership is required.";
        if (!formData.propertyDetails.location_hub) newErrors.location_hub = "Location Hub is required.";
        if (['others'].includes(formData.propertyDetails.location_hub)) {
          if (!formData.propertyDetails.other_location_hub.trim()) newErrors.other_location_hub = "Other Location Hub is required.";
        }
        if (!formData.propertyDetails.buildup_area.trim()) newErrors.buildup_area = "Build Up is required.";
        if (!formData.propertyDetails.carpet_area.trim()) {
          newErrors.carpet_area = "Carpet Area is required.";
        } else if (parseFloat(formData.propertyDetails.carpet_area) >= parseFloat(formData.propertyDetails.buildup_area)) {
          newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
        }
        if (!formData.propertyDetails.property_name.trim()) newErrors.property_name = "Property Name is required.";
      }
    }
    if (activeStep === 2) {
      if (!formData.propertyPrice.pricing.trim()) newErrors.pricing = "Price is required.";
      // if (!formData.propertyPrice.cost.trim()) newErrors.cost = "Cost of the property required.";
      if (!formData.propertyPrice.security_deposit_month.trim()) newErrors.security_deposit_month = "Choose Security Deposit.";


      if (['custom'].includes(formData.propertyPrice.security_deposit_month)) {
        if (!formData.propertyPrice.security_deposit_amount.trim()) {
          newErrors.security_deposit_amount = "Security Amount is required";
        }
      }
    }
  }

  return newErrors;
};


export default validateForm;


export const projectValidation = (formData) =>{
  const newErrors = {};
  if (!formData.projectDetails.projectName) newErrors.projectName = "Project Name is required.";
  if (!formData.projectDetails.city) newErrors.city = "Select City is required.";
  if (!formData.projectDetails.state) newErrors.state = "Select State is required.";
  if (!formData.projectDetails.projectDescription) newErrors.projectDescription = "Project Description is required.";
  if (!formData.projectDetails.locality) newErrors.locality = "Select Sub Locality is required.";
  if (!formData.projectDetails.category) newErrors.category = "Select Project Category is required.";
  if (
    formData.projectDetails.projectArea &&
    String(formData.projectDetails.areaUnit || "").trim() === ""
  ) {
    newErrors.areaUnit = "Area Unit is required when Project Area is filled.";
  }
  
  
  return newErrors;
}


export const propertyValuationValidation = (activeStep,formData) =>{
  const newErrors = {};
  if (!formData.propertyDetails.property_category) newErrors.property_category = "Property Category is required.";
  if (!formData.propertyDetails.property_type) newErrors.property_type = "Select Property Type is required.";
  if (!formData.propertyDetails.locality) newErrors.locality = "Select Sub Locality is required.";
  if (["apartment","villa","independent_floor","independent_house"].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.bhk) newErrors.bhk = "BHK is required.";
  }
  if (['plot'].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.corner_plot) newErrors.corner_plot = "Corner Plot is required.";
    if (!formData.propertyDetails.plot_authority) newErrors.plot_authority = "Plot Authority is required.";
  }
  if (['agricultural_land'].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.plot_authority) newErrors.plot_authority = "Plot Authority is required.";
  }
  if (['office','showroom','retailshop','warehouse'].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Total Floor is required.";
    if (!formData.propertyDetails.floor) newErrors.floor = "Floor is required.";
  }
  if (activeStep === 1) {
    if (["apartment","villa","independent_floor","independent_house"].includes(formData.propertyDetails.property_type)) {
      if (!formData.propertyDetails.property_age) newErrors.property_age = "Property Age is required.";
      if (!formData.propertyDetails.interiors) newErrors.interiors = "Interiors is required.";
      if (!formData.propertyDetails.buildup_area) newErrors.buildup_area = "Build up Area is required.";
    }

    if (['plot','agricultural_land'].includes(formData.propertyDetails.property_type)) {
      if (!formData.propertyDetails.width_facing_road) newErrors.width_facing_road = "Width of Facing Road is required.";
      if (!formData.propertyDetails.plot_area) newErrors.plot_area = "Area is required.";
      if (!formData.propertyDetails.length) newErrors.length = "Length is required.";
      if (!formData.propertyDetails.width) newErrors.width = "Width is required.";
    }

    if (['agricultural_land'].includes(formData.propertyDetails.property_type)) {
      if (!formData.propertyDetails.area_unit) newErrors.area_unit = "Area Unit is required.";
    }

    if (['office','showroom','retailshop','warehouse'].includes(formData.propertyDetails.property_type)) {
      if (!formData.propertyDetails.property_age) newErrors.property_age = "Property Age is required.";
      if (!formData.propertyDetails.buildup_area) newErrors.buildup_area = "Build up Area is required.";
    }
    if (['warehouse'].includes(formData.propertyDetails.property_type)) {
      if (!formData.propertyDetails.buildup_area) newErrors.buildup_area = "Build up Area is required.";
    }
    
    }

    if(activeStep === 2){

      const { reminder_date, reminder_time } = formData.propertyDetails;
      if (!formData.propertyDetails.reminder_date) {
        newErrors.reminder_date = "Please select a reminder date.";
      }
    
      if (!formData.propertyDetails.reminder_time) {
        newErrors.reminder_time = "Please select a reminder time.";
      }
    
      if (formData.propertyDetails.reminder_date && formData.propertyDetails.reminder_time) {
        const selectedDateTime = new Date(`${reminder_date}T${reminder_time}`);
        const now = new Date();
    
        if (selectedDateTime < now) {
          newErrors.reminder_time = "Reminder date and time cannot be in the past.";
        }
      }
    }

  return newErrors;
}
